/** @format */

import { useEffect, useRef, useState } from 'react';
import { SimCardServiceGroup, SimCardServiceGroupCollection } from '../../../interfaces/collections/SimCardServiceInterface';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import Filter from '../../../interfaces/forms/Filter';
import { useFilterParseToArray } from './useFilterParseToArray';
import { HeaderCheckBoxSelectListElement } from '../../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { OperatorMvneTypeMap } from './useOperatorType';

export const useSimCardServiceGroupList = (operatorIds: Array<number> | null, getAll?: boolean | null): SimCardServiceGroupCollection | null => {
    const dispatch = useDispatch();
    const [groupList, setGroupList] = useState<SimCardServiceGroupCollection | null>(null);
    const filters = useRef<Array<Filter>>([]);
    const prepareFilter: Array<Filter> = !getAll ? [{ name: 'visible', value: true }] : [];

    prepareFilter.push({ name: 'operatorType[]', value: OperatorMvneTypeMap.OPL });
    filters.current = useFilterParseToArray(prepareFilter, false);
    useEffect(() => {
        if (groupList === null) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_groups')),
                'sim_card_services_groups_list_load',
                filters.current,
                [{ value: 'asc', name: 'mainname' }],
                (data: SimCardServiceGroupCollection): void => {
                    setGroupList(data);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, groupList, filters]);
    return groupList;
};

export const useSimCardServiceGroupHeader = (
    simCardServiceGroupCollection?: SimCardServiceGroupCollection | null
): Array<HeaderCheckBoxSelectListElement> => {
    const selectSimCardServicesGroup: Array<HeaderCheckBoxSelectListElement> = [];
    if (!simCardServiceGroupCollection) {
        return [];
    }
    for (let i = 0; i < simCardServiceGroupCollection['hydra:member'].length; i++) {
        selectSimCardServicesGroup.push({
            name: simCardServiceGroupCollection['hydra:member'][i].mainname,
            value: simCardServiceGroupCollection['hydra:member'][i].id,
        });
    }
    return selectSimCardServicesGroup;
};

export const useSimCardServiceGroup = (
    simCardServiceGroupCollection: SimCardServiceGroupCollection | null,
    groupId?: number | null
): SimCardServiceGroup | null => {
    if (simCardServiceGroupCollection === null || !groupId) {
        return null;
    }
    for (let i = 0; i < simCardServiceGroupCollection?.['hydra:member'].length; i++) {
        if (groupId === simCardServiceGroupCollection['hydra:member'][i].id) {
            return simCardServiceGroupCollection['hydra:member'][i];
        }
    }
    return null;
};
